import React from 'react'
import { Link } from 'react-router-dom'
import ThreeDot from '../common/ThreeDot'

export default function RetailerOrder() {
  return (
    <div className="content-body">
          {/* Work in progress */}
          {/* <div className="container-fluid">
        <div className="row">
        <div className="col-xl-12 col-xxl-12 col-lg-12 col-sm-12">
        <div className="card py-5">
          <div className="card-body py-5 my-5">
            <div className="text-center py-5 my-5 fs-1">
            Work in progress
            </div>
          </div>
          </div></div>
        </div>
      </div> */}
      {/* end */}
    <div className="container-fluid">
      <div className="form-head d-flex mb-3 align-items-start justify-content-between">
        {/* <div className="input-group search-area d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search here"
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fas fa-search"></i>
            </span>
          </div>
        </div> */}
        <div>
        <Link to="/retailer">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>{" "}
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <div
              id="example5_wrapper"
              className="dataTables_wrapper no-footer"
            >
              <table
                id="example5"
                className="display mb-4 dataTablesCard dataTable no-footer table order-request2"
                role="grid"
                aria-describedby="example5_info"
              >
                <thead>
                  <tr role="row">
                    <th>
                      <strong className="font-w600">Order ID</strong>
                    </th>
                    <th>
                      <strong className="font-w600">Order Date</strong>
                    </th>
                    <th>
                      <strong className="font-w600">Order Status</strong>
                    </th>
                    <th>
                      <strong className="font-w600">Total Items</strong>
                    </th>
                    <th>
                      <strong className="font-w600">Order Total (₹)</strong>
                    </th>
                    <th>
                      <strong className="font-w600">Payment Status</strong>
                    </th>
                    <th>
                      <strong className="font-w600">Delivery Date</strong>
                    </th>
                    <th>
                      <strong className="font-w600"></strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr role="row" className="odd">
                    <td>101</td>
                    <td>2023-11-20</td>
                    <td>Pending</td>
                    <td>
                      12
                    </td>
                    <td>₹15,000</td>
                    <td>Unpaid</td>
                    <td>
                    2023-11-25
                    </td>
                    <td>
                      <div className="dropdown ms-auto c-pointer">
                       <ThreeDot />
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link
                            className="dropdown-item text-black"
                            to="/retailer/orders-details"
                          >
                            <svg
                              className="me-2"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 16V12"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 8H12.01"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            View Details
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr role="row" className="odd">
                    <td>102</td>
                    <td>2023-11-18</td>
                    <td>Delivered</td>
                    <td> 8</td>
                    <td>₹10,000</td>
                    <td>paid</td>
                    <td>
                    2023-11-23
                    </td>
                    <td>
                      <div className="dropdown ms-auto c-pointer">
                       <ThreeDot />
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link
                            className="dropdown-item text-black"
                            to="/retailer/orders-details"
                          >
                            <svg
                              className="me-2"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 16V12"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 8H12.01"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            View Details
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr role="row" className="odd">
                    <td>103</td>
                    <td>2023-12-20</td>
                    <td>Cancelled</td>
                    <td>
                      20
                    </td>
                    <td>₹20,000</td>
                    <td>Unpaid</td>
                    <td>
                    N/A
                    </td>
                    <td>
                      <div className="dropdown ms-auto c-pointer">
                        <ThreeDot />
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link
                            className="dropdown-item text-black"
                            to="/retailer/orders-details"
                          >
                            <svg
                              className="me-2"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 16V12"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 8H12.01"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            View Details
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr role="row" className="odd">
                    <td>104</td>
                    <td>2024-12-20</td>
                    <td>Shipped</td>
                    <td>
                      20
                    </td>
                    <td>₹20,000</td>
                    <td>Paid</td>
                    <td>
                    2023-11-23
                    </td>
                    <td>
                      <div className="dropdown ms-auto c-pointer">
                        <ThreeDot />
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link
                            className="dropdown-item text-black"
                            to="/retailer/orders-details"
                          >
                            <svg
                              className="me-2"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 16V12"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 8H12.01"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            View Details
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr role="row" className="odd">
                    <td>101</td>
                    <td>2023-11-20</td>
                    <td>Pending</td>
                    <td>
                      12
                    </td>
                    <td>₹15,000</td>
                    <td>Unpaid</td>
                    <td>
                    2023-11-25
                    </td>
                    <td>
                      <div className="dropdown ms-auto c-pointer">
                       <ThreeDot />
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link
                            className="dropdown-item text-black"
                            to="/retailer/orders-details"
                          >
                            <svg
                              className="me-2"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 16V12"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 8H12.01"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            View Details
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr role="row" className="odd">
                    <td>102</td>
                    <td>2023-11-18</td>
                    <td>Delivered</td>
                    <td> 8</td>
                    <td>₹10,000</td>
                    <td>paid</td>
                    <td>
                    2023-11-23
                    </td>
                    <td>
                      <div className="dropdown ms-auto c-pointer">
                        <ThreeDot />
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link
                            className="dropdown-item text-black"
                            to="/retailer/orders-details"
                          >
                            <svg
                              className="me-2"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 16V12"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 8H12.01"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            View Details
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr role="row" className="odd">
                    <td>103</td>
                    <td>2023-12-20</td>
                    <td>Cancelled</td>
                    <td>
                      20
                    </td>
                    <td>₹20,000</td>
                    <td>Unpaid</td>
                    <td>
                    N/A
                    </td>
                    <td>
                      <div className="dropdown ms-auto c-pointer">
                        <ThreeDot />
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link
                            className="dropdown-item text-black"
                            to="/retailer/orders-details"
                          >
                            <svg
                              className="me-2"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 16V12"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 8H12.01"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            View Details
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr role="row" className="odd">
                    <td>104</td>
                    <td>2024-12-20</td>
                    <td>Shipped</td>
                    <td>
                      20
                    </td>
                    <td>₹20,000</td>
                    <td>Paid</td>
                    <td>
                    2023-11-23
                    </td>
                    <td>
                      <div className="dropdown ms-auto c-pointer">
                        <ThreeDot />
                        <div className="dropdown-menu dropdown-menu-end">
                          <Link
                            className="dropdown-item text-black"
                            to="/retailer/orders-details"
                          >
                            <svg
                              className="me-2"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 16V12"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 8H12.01"
                                stroke="#6F6F6F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            View Details
                          </Link>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
    
            </div>
          </div>
        </div>
      </div>
      <div className="dataTables_wrapper no-footer">
              <div
                className="dataTables_info"
                id="example5_info"
                role="status"
                aria-live="polite"
              >
                Showing 1 to 10 of 11 entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous"
                  aria-controls="example5"
                  data-dt-idx="0"
                  tabIndex="0"
                  id="example5_previous"
                >
                  Previous
                </Link>
                <span>
                  <Link
                    className="paginate_button current"
                    aria-controls="example5"
                    data-dt-idx="1"
                    tabIndex="0"
                  >
                    1
                  </Link>
                  <Link
                    className="paginate_button "
                    aria-controls="example5"
                    data-dt-idx="2"
                    tabIndex="0"
                  >
                    2
                  </Link>
                </span>
                <Link
                  className="paginate_button next"
                  aria-controls="example5"
                  data-dt-idx="3"
                  tabIndex="0"
                  id="example5_next"
                >
                  Next
                </Link>
              </div>
            </div>
    </div>
  </div>
  )
}
